import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import WebinarSessionLinkInterface from 'common/types/entities/WebinarSessionLinkInterface'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { ResetEntityStyles } from 'src/editor/shared/settings/reset-entity-styles-button'
import Input from '../../../components/core/Sidebar/components/Settings/components/Input/Input'
import { useUpdateProp } from '../../../components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import DeviceAppearanceNew from '../../../components/core/Sidebar/components/Settings/options/DeviceAppearance/DeviceAppearanceNew'
import HtmlAttrId from '../../../components/core/Sidebar/components/Settings/options/HtmlAttrId'
import FontSize from '../../../components/core/Sidebar/components/Settings/styles/FontSize'
import TextAlignStyle from '../../../components/core/Sidebar/components/Settings/styles/TextAlignStyle'

function WebinarSessionLinkSettingsNew({
  entity,
  defaultEntity,
}: {
  entity: WebinarSessionLinkInterface
  defaultEntity?: WebinarSessionLinkInterface
}) {
  const { isMobile } = useDeviceModeContext()
  const updateProp = useUpdateProp(entity)

  return (
    <>
      <GroupTitle
        withoutHorizontalLine
        afterChildren={
          defaultEntity && (
            <ResetEntityStyles
              entity={entity}
              defaultEntity={defaultEntity}
              keys={['fontSize', 'textAlign', 'color']}
              mobileKeys={['mobileFontSize', 'mobileTextAlign', 'mobileColor']}
            />
          )
        }
      >
        typography
      </GroupTitle>
      <FontSize
        update={updateProp('fontSize')}
        mobileUpdate={updateProp('mobileFontSize')}
        fontSize={entity.fontSize}
        mobileFontSize={entity.mobileFontSize}
      />
      <Input
        label="link text"
        update={updateProp('text')}
        value={entity.text}
      />
      <ColorPickerControl
        update={updateProp('color')}
        mobileUpdate={updateProp('mobileColor')}
        color={entity.color}
        mobileColor={entity.mobileColor}
      />
      <TextAlignStyle
        textAlign={entity.textAlign || 'left'}
        mobileTextAlign={entity.mobileTextAlign || entity.textAlign || 'left'}
        update={updateProp('textAlign')}
        mobileUpdate={updateProp('mobileTextAlign')}
      />
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        defaultMargin={
          isMobile ? defaultEntity?.mobileMargin : defaultEntity?.margin
        }
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearanceNew entity={entity} />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default WebinarSessionLinkSettingsNew
